import { useState } from 'react';
import { Schema } from '@formily/react';
import { uuid } from '../';
import { isPlainObj } from '@formily/shared';
import { isExpression } from '../utils';
const NeedShownExpression = {
    title: true,
    description: true,
    default: true,
    'x-content': true,
    'x-value': true,
};
const NeedIgnoreFormilyProps = {
    'x-reactions': true,
    'x-validator': true,
};
const traverse = (obj, cb) => {
    if (isPlainObj(obj)) {
        Object.keys(obj).forEach((key) => {
            traverse(obj[key], cb);
            obj[key] = cb(key, obj[key]);
        });
    }
};
const useSchema = ({ componentProps = {}, fieldProps, decoratorProps = {}, style, __designMode, ...extra }, defaultProps) => {
    const { name, ...rest } = fieldProps;
    const [initialName] = useState(uuid());
    const isDesignMode = __designMode === 'design';
    const isReadOnly = isDesignMode ? true : defaultProps?.readOnly || rest?.readOnly;
    const schema = {
        type: 'object',
        properties: {
            [name || initialName]: {
                'x-decorator': 'FormItem',
                ...defaultProps,
                ...rest,
                readOnly: isReadOnly,
                'x-component-props': {
                    style,
                    ...componentProps['x-component-props'],
                    ...(extra || {}),
                },
                ...decoratorProps,
            },
        },
    };
    if (isDesignMode) {
        traverse(schema, (key, value) => {
            if (NeedIgnoreFormilyProps[key]) {
                return null;
            }
            else if (isExpression(value)) {
                if (NeedShownExpression[key]) {
                    return `{{${value}}}`;
                }
            }
            else {
                return value;
            }
        });
    }
    return new Schema(schema);
};
export default useSchema;
